module.exports = __webpack_public_path__ + "img/judgement.626369f0.png";